// Iter-282 — shared recent-search helpers.
//
// Two consumers call `recordRecentSearch(term, isSignedIn, qc)`:
//   1. Header.jsx (plain Enter submit — bypasses the panel entirely)
//   2. TopSearchResults.jsx (chip clicks, "See all", grouped-result clicks)
//
// Guest mode:  writes localStorage[RECENT_KEY] (newest first, cap 8).
// Signed-in:   fires POST /api/search/recent with {term}. On success, if
//              a `qc` (react-query QueryClient) is passed, invalidates the
//              ['search-recent', true] query so any open panel refreshes.
//              Errors are silent — recent-history writes must never block
//              navigation.
import { sharedApi } from "@/lib/api";

export const RECENT_KEY = "allsale_recent_searches";
export const RECENT_MAX = 8;

export function readLocalRecent() {
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((s) => typeof s === "string").slice(0, RECENT_MAX) : [];
  } catch { return []; }
}

export function writeLocalRecent(list) {
  try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); }
  catch { /* localStorage disabled */ }
}

function pushLocalRecent(term) {
  const cur = readLocalRecent().filter((s) => s.toLowerCase() !== term.toLowerCase());
  cur.unshift(term);
  writeLocalRecent(cur);
}

export function recordRecentSearch(term, isSignedIn, qc) {
  const trimmed = (term || "").trim();
  if (!trimmed) return;
  if (isSignedIn) {
    // Fire-and-forget — never await; the caller navigates immediately.
    sharedApi.post("/search/recent", { term: trimmed })
      .then(() => {
        // Bust the panel's server-recent cache so the newly-submitted
        // term appears at the top on next open (30s staleTime otherwise).
        if (qc) qc.invalidateQueries({ queryKey: ["search-recent"] });
      })
      .catch(() => {});
  } else {
    pushLocalRecent(trimmed);
  }
}
